import { createApp } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'

import VueChartkick from 'vue-chartkick'
import 'chartkick/chart.js'

import SearchForm from '../components/SearchForm.vue'
import ProductSearch from '../components/ProductSearch.vue'
import ProductSearchItem from '../components/ProductSearchItem.vue'
import QuotationSuggestions from '../components/QuotationSuggestions.vue'
import FullScreenOverlay from '../components/FullScreenOverlay.vue'
import EmptyStateSuggestion from '../components/EmptyStateSuggestion.vue'
import SupplierMap from '../components/SupplierMap.vue'
import SupplierContracts from '../components/SupplierContracts.vue'
import ReportGroups from '../components/ReportGroups.vue'
import ReportGroupSummary from '../components/ReportGroupSummary.vue'
import ReportGroup from '../components/ReportGroup.vue'
import ReportItemDetails from '../components/ReportItemDetails.vue'
import SkeletonSummary from '../components/SkeletonSummary.vue'
import SkeletonReportGroup from '../components/SkeletonReportGroup.vue'
import AiReportWizard from '../components/AiReportWizard.vue'
import SupportChat from '../components/SupportChat.vue'
import S3FileUpload from '../components/S3FileUpload.vue'
import ScoreFeedbackModal from '../components/score_feedback_modal.js'

import { BButton, BCard, BFormInput } from 'bootstrap-vue-next';

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp({
    data() {
      return {
        uploadedFiles: []
      };
    },
    methods: {
      async handleFileUploaded(file) {
        // Salvar no banco de dados
        try {
          const fileUploadData = {
            filename: file.name,
            file_url: file.url,
            file_key: file.key,
            content_type: file.type || 'application/octet-stream',
            file_size: file.size
          };
          
          console.log('Enviando dados para salvar:', fileUploadData);
          
          const response = await fetch('/file_uploads', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({
              file_upload: fileUploadData
            })
          });
          
          if (response.ok) {
            const data = await response.json();
            // Adicionar ID do banco ao arquivo
            file.id = data.file_upload.id;
            this.uploadedFiles.push(file);
            this.showSuccessMessage('Arquivo enviado e salvo com sucesso!');
            
            // Redirecionar para a página de detalhes do arquivo após 1.5 segundos
            setTimeout(() => {
              window.location.href = `/file_uploads/${data.file_upload.id}`;
            }, 1500);
          } else {
            const errorData = await response.json();
            console.error('Erro ao salvar arquivo:', errorData);
            this.showErrorMessage('Arquivo enviado mas não foi salvo no banco: ' + errorData.message);
          }
        } catch (error) {
          console.error('Erro ao salvar arquivo:', error);
          this.showErrorMessage('Erro ao salvar arquivo no banco');
        }
      },
      
      async handleFileRemoved(file) {
        const index = this.uploadedFiles.findIndex(f => f.key === file.key);
        if (index > -1) {
          // Se o arquivo tem ID (foi salvo no banco), remover do banco também
          if (file.id) {
            try {
              const response = await fetch(`/file_uploads/${file.id}`, {
                method: 'DELETE',
                headers: {
                  'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                }
              });
              
              if (response.ok) {
                this.uploadedFiles.splice(index, 1);
                this.showSuccessMessage('Arquivo removido com sucesso!');
              } else {
                this.showErrorMessage('Erro ao remover arquivo do servidor');
              }
            } catch (error) {
              console.error('Erro ao remover arquivo:', error);
              this.showErrorMessage('Erro ao remover arquivo');
            }
          } else {
            // Arquivo ainda não foi salvo no banco, apenas remover da lista
            this.uploadedFiles.splice(index, 1);
            this.showInfoMessage('Arquivo removido da lista');
          }
        }
      },
      
      removeFile(file) {
        this.handleFileRemoved(file);
      },
      
      formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
      },
      
      showSuccessMessage(message) {
        this.showToast(message, 'success');
      },
      
      showInfoMessage(message) {
        this.showToast(message, 'info');
      },
      
      showErrorMessage(message) {
        this.showToast(message, 'error');
      },
      
      showToast(message, type = 'success') {
        const bgColor = type === 'success' ? 'success' : type === 'error' ? 'danger' : 'info';
        const iconClass = type === 'success' ? 'check-circle' : type === 'error' ? 'exclamation-triangle' : 'info-circle';
        
        const toastHtml = `
          <div class="toast align-items-center text-white bg-${bgColor} border-0" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="d-flex">
              <div class="toast-body">
                <i class="fas fa-${iconClass} me-2"></i>
                ${message}
              </div>
              <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
            </div>
          </div>
        `;
        
        // Criar container de toast se não existir
        let toastContainer = document.getElementById('toast-container');
        if (!toastContainer) {
          toastContainer = document.createElement('div');
          toastContainer.id = 'toast-container';
          toastContainer.className = 'toast-container position-fixed bottom-0 end-0 p-3';
          document.body.appendChild(toastContainer);
        }
        
        // Adicionar toast
        const toastElement = document.createElement('div');
        toastElement.innerHTML = toastHtml;
        toastContainer.appendChild(toastElement.firstElementChild);
        
        // Mostrar toast
        const toast = new bootstrap.Toast(toastContainer.lastElementChild);
        toast.show();
        
        // Remover após 5 segundos
        setTimeout(() => {
          toastContainer.lastElementChild.remove();
        }, 5000);
      }
    }
  });

  const aliases = {
    'b-btn': BButton,
    'b-cardcomponent': BCard,
    'b-input': BFormInput,
  };  

  const bootstrapVueOptions = {
    components: {
      BButton,
      BCard,
      BFormInput,
    },
    aliases
  };

  app.use(createBootstrap(bootstrapVueOptions));
  app.component('EmptyStateSuggestion', EmptyStateSuggestion);
  app.component('SearchForm', SearchForm);
  app.component('ProductSearch', ProductSearch);
  app.component('ProductSearchItem', ProductSearchItem);
  app.component('QuotationSuggestions', QuotationSuggestions);
  app.component('FullScreenOverlay', FullScreenOverlay);
  app.component('SupplierMap', SupplierMap);
  app.component('SupplierContracts', SupplierContracts);
  app.component('ReportGroups', ReportGroups);
  app.component('ReportGroupSummary', ReportGroupSummary);
  app.component('ReportGroup', ReportGroup);
  app.component('ReportItemDetails', ReportItemDetails);
  app.component('SkeletonSummary', SkeletonSummary);
  app.component('SkeletonReportGroup', SkeletonReportGroup);
  app.component('AiReportWizard', AiReportWizard);
  app.component('S3FileUpload', S3FileUpload);
  app.use(VueChartkick);
  app.mount('#app');
  
  // Initialize Support Chat (separate Vue instance)
  if (document.getElementById('support-chat-container')) {
    const chatApp = createApp({});
    chatApp.component('SupportChat', SupportChat);
    chatApp.mount('#support-chat-container');
  }
  
  // Initialize Score Feedback Modal
  new ScoreFeedbackModal();
})